import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';

import Radio from '../../forms/Radio/Radio';
import GrassSizeCart from './GrassSizeCart';
import useMediaSize from '../../../hooks/useMediaSize';
import { $cartState } from '../../../store/models/cart';
import { $productsState } from '../../../store/models/products';
import { fetchGetAllProductsFx } from '../../../store/models/products/effects';

import styles from './styles.module.scss';

type Props = {
  handleSelect: (event: any) => void;
};

const GrassSizeRadio = ({ handleSelect }: Props) => {
  const { t } = useTranslation();
  const { grasses } = useUnit($productsState);
  const { selectedProductSize } = useUnit($cartState);

  useEffect(() => {
    fetchGetAllProductsFx();
  }, []);

  const sizesData = grasses.map((dt) => {
    return {
      value: dt.size,
      cardContent: (
        <GrassSizeCart
          size={dt.size}
          price={dt.actual_price}
          info={t(`grassSizes.${dt.size}.info`)}
          label={t(`grassSizes.${dt.size}.label`)}
          allowedWeight={t(`grassSizes.${dt.size}.allowedWeight`)}
        />
      ),
    };
  });

  const { isSmallDesktop, isTablet, isMobile } = useMediaSize();

  let gridStr = '1fr';
  if (isMobile) {
    gridStr = '1fr';
  } else if (isSmallDesktop || isTablet) {
    gridStr = '1fr 1fr';
  } else {
    gridStr = '1fr 1fr 1fr 1fr';
  }

  return (
    <div className={styles.grassSizeRadio}>
      <Radio
        data={sizesData}
        handleSelect={handleSelect}
        selectedOption={selectedProductSize}
        extraStyle={{
          gridTemplateColumns: gridStr,
        }}
      />
    </div>
  );
};

export default GrassSizeRadio;
